import { render, staticRenderFns } from "./doctor-specialties.html?vue&type=template&id=b460feec&scoped=true&external"
import script from "./doctor-specialties.js?vue&type=script&lang=js&external"
export * from "./doctor-specialties.js?vue&type=script&lang=js&external"
import style0 from "./doctor-specialties.scss?vue&type=style&index=0&id=b460feec&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b460feec",
  null
  
)

export default component.exports